import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { CreateInvoiceModal } from './CreateInvoiceModal'

interface Props {
  requestId: string
  /** Юрлицо, выбранное в окне счёта по умолчанию (см. CreateInvoiceModal). */
  defaultEntityId?: string | null
  /** Подпись кнопки. */
  label?: string
  className?: string
  /** Заказ уже оформлен — окно не предлагает условий оплаты. */
  forExistingOrder?: boolean
}

/**
 * Кнопка «Выгрузить шаблон для счёта в УНФ» — точка входа в Блок 2 из карточки
 * заявки/деталей КП. Создаёт (или пополняет) заказ по позициям в статусе «Счёт»
 * и открывает карточку заказа. Доступна, когда у заявки есть ORDERED-позиции
 * (если их нет — бэк вернёт понятную ошибку, показывается в модале).
 */
export function CreateOrderButton({
  requestId,
  defaultEntityId,
  label,
  className,
  forExistingOrder,
}: Props) {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  return (
    <>
      <button
        type="button"
        className={
          className ??
          'rounded-lg bg-emerald-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-emerald-700'
        }
        onClick={() => setOpen(true)}
      >
        {label ?? 'Выгрузить шаблон счёта (УНФ)'}
      </button>
      {open && (
        <CreateInvoiceModal
          requestId={requestId}
          defaultEntityId={defaultEntityId}
          forExistingOrder={forExistingOrder}
          onClose={() => setOpen(false)}
          onCreated={(orderId) => {
            setOpen(false)
            navigate(`/orders/${orderId}`)
          }}
        />
      )}
    </>
  )
}
